var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTreadOpens = function SvgTreadOpens(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 32h32V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC40",
    fillRule: "nonzero",
    d: "M14.124 32c3.085 0 5.593-2.457 5.593-5.5v-4.999h8.175a4.1 4.1 0 0 0 2.943-1.197l.162-.17a3.96 3.96 0 0 0 .956-3.238L29.841 3.398C29.535 1.423 27.8-.022 25.79 0H8a1 1 0 0 0-1 1v16.5a1 1 0 0 0 .09.414l6.123 13.5a1 1 0 0 0 .911.586M4.471 18c.497 0 .9-.424.9-.947V.948c0-.523-.403-.947-.9-.947h-1.09C1.247-.037.3 1.551.01 3.715L0 3.847v10.146l.009.133C.303 16.312 1.267 18.037 3.366 18z"
  }))));
};
export default SvgTreadOpens;